import React from "react";
import { Row, Col, Button, ButtonGroup } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState, useCallback, useEffect, useRef } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import * as Icon from "react-bootstrap-icons";
import { ThreeCircles } from "react-loader-spinner";
import { getFromLS } from "../../../utils/storage";
import { OptimiseChartModal } from "./OptimizeStaffing";
import {
  setPrimaryBarData,
  cleanedBarData,
  defaultBarData,
} from "./StaffingHelperFunctions";
import { MainGrid } from "./StaffingGrids";
import { MainChart } from "./StaffingCharts";
import { logout } from "../../../utils";
import { TemplateDownloadRenderer } from "../TemplateDownloadRenderer";
import DropFileInput from "../../../reusable-components/DropFileComponent/DropFileComponent";
import { NoAccessPopup } from "../../../reusable-components/NoAccessPopupComponent/NoAccessModal";
import { Document, Text, Page, PDFViewer, PDFDownloadLink, StyleSheet, View } from '@react-pdf/renderer';
import Modal from "react-bootstrap/Modal";
import OffCanvasNavbar from "../reportNavbar";
import { TemplateDescriptionPopover } from "../TemplatePopoverlay";
const styles = StyleSheet.create({
  page: {
    textAlign: 'center',
    width: "100%",
    marginTop: 30,
    fontSize: 30,
  },
  container: {
    width: '100%',
  },
  text: {
    color: '#228b22',
  },
  layout: {
    marginTop: 30,
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});

// const MyDocument = (props) => (
//   <Document>
//     <Page style={styles.page}>
//       <View style={styles.layout}>
//         <View>
//         <MainChart
//             primarySeries={primarySeries}
//             colors={localChartTheme.colors}
//             categories={categories}
//           />
//         </View>
//         <View>
//         <MainGrid rowData={rowData} onGridReady={onGridReady} />
//         </View>
//       </View>
//     </Page>
//   </Document>
// );

const StaffingReport = () => {
  const featureName = "Staffing Report";
  const accessibleFeatures = getFromLS('active-features')

  // Check for access else return no access modal
  // const [noAccessModalShow, setNoAccessModalShow]=useState(false)
  // if(!accessibleFeatures.includes(featureName)){
  //   return(
  //     <NoAccessPopup 
  //     featurename={featureName}
  //     />
  //   )
  // }
  // set user creds
  const [firm_id, setFirmId] = useState(getFromLS("firmId"));
  const [vendor, setVendor] = useState("xcm");
  // declare default grid params
  const [rowData, setRowData] = useState([]);

  // set default API params
  const [reportApiResponse, setReportApiResponse] = useState({
    data: { 0: { report: { staff: [] } } },
  });

  // set local mode params
  const [localApiResponse, setLocalApiResponse] = useState({
    data: { 0: { report: { staff: [] } } },
  });
  const [template_file_list, setTemplateFileList] = useState([]);
  const [templateDescription, setTemplateDescription] = useState("")
  const [localMode, setLocalMode] = useState(false);
  const [localLoaderToggle, setLocalLoaderToggle] = useState(true);

  // set loader params
  const [isLoading, setIsLoading] = useState(true);

  // set app params
  const localChartTheme = getFromLS("chart-theme");

  // set default data for chart and chips
  const [hours, setHours] = useState();
  const [recentDate, setRecentDate] = useState();
  const [primarySeries, setPrimarySeries] = useState([]);
  const [categories, setCategories] = useState([]);

  // Toggle clean chart functionality
  const [cleanToggle, setCleanToggle] = useState(false);
  const [cleanOriginal, setCleanOriginal] = useState("Original");

  const [loaderText, setLoaderText] = useState(false);
  const [chartSvg, setChartSvg] = useState()
  const setChartRef = (ref) => {
    setChartSvg(chartSvg)
  }

  let handleClean = (e) => {
    setCleanToggle(!cleanToggle);
    if (cleanToggle) {
      e.preventDefault();
      let [categories, barChartData] = defaultBarData(reportApiResponse);
      setCategories(categories);
      setPrimarySeries(barChartData);
      setCleanOriginal("Original");
    } else {
      e.preventDefault();
      let [categories, barChartData] = cleanedBarData(reportApiResponse);
      setCategories(categories);
      setPrimarySeries(barChartData);
      setCleanOriginal("Cleaned");
    }
  };

  const Switch = ({ isToggled, onClick }) => {
    return (
      <label className="switch">
        <input type="checkbox" checked={isToggled} onChange={onClick} />
        <span className="slider round"></span>
      </label>
    );
  };

  // set default params required for optimise staffing
  const [chartModalShow, setChartModalShow] = useState(false);
  const [pdfModal, setPdfModal] = useState(false);


  // PDF modal
  const PdfModal = (props) => {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        className={"comparison-modal"}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Staffing Report PDF
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PDFViewer>
            <MyDocument />
          </PDFViewer>
        </Modal.Body>
        <Modal.Footer>
          <PDFDownloadLink document={<MyDocument />} fileName="somename.pdf">
            {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download now!')}
          </PDFDownloadLink>
        </Modal.Footer>
      </Modal>
    )
  }
  // maitain api response
  const setApiData = (result, localMode = false) => {
    console.log("API DATA: ", result)
    if (localMode) {
      setLocalApiResponse(result);
    } else {
      setReportApiResponse(result);
    }
    return result;
  };

  // call api and get data
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ firm_id, vendor }),
  };

  let gridApi;
  const onGridReady = useCallback((params) => {
    gridApi = params.api;
    gridApi.closeToolPanel();
  }, []);

  const getStaffingDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/report/staffing/`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          if (response.status === 401) {
            // Handle unauthorized error
            logout();
            alert("Session ended , Please login back");
          } else {
            throw new Error("Request failed.");
          }
        }
        return response.json();
      })
      .then((result) => setApiData(result))
      // Maintaining the templatye files sent from API response
      .then((result) => (setTemplateFiles(result)))
  };


  /**
   * In this functionm, we pass the API response to extract template links to be displayed in local mode.
   * @param {*} result: API response.
   * @returns API response (for further use).
   */
  const setTemplateFiles = (result) => {
    const templates = result.data[0].report.templates
    setTemplateFileList(templates)
    const templateDescriptionHolder = []
    for(let template in templates){
      Object.assign(templateDescriptionHolder, {[templates[template].name + templates[template].extension]: templates[template].description})
    }
    setTemplateDescription(templateDescriptionHolder)
    return result
  }

  /**
   * This function enables the local mode and maintains the state of loaders and messages to be displayed.
   */
  const LocalModeEnabler = () => {
    setLocalLoaderToggle(true);
    if (localMode) {
      console.log("LOCAL MODE API RESPONSE: ", localApiResponse)
      setLoaderText(true);
      setApiData(localApiResponse, false);
      setLocalLoaderToggle(false);
    }
    setLocalMode(!localMode);
  };

  const filesMap = {
    "TemplateUserDetail": "",
    "TemplateTaskDetails": ""
  }

  /**
   * This function accepts the uploaded template excel files and adds them to the payload for making Local Mode API call
   * @param {*} files 
   * @param {*} filename 
   */
  const onFileChange = (files, filename) => {
    console.log("FILENAME: ", filename)
    console.log("FILES: ", files)
    const formData = new FormData();
    if (filename == "TemplateUserDetail") {
      filesMap.TemplateUserDetail = files[0]
    } else if (filename == "TemplateTaskDetails") {
      filesMap.TemplateTaskDetails = files[0]
    }
    console.log("FILES: ", filesMap)
    if (filesMap.TemplateUserDetail != "" && filesMap.TemplateTaskDetails != "") {
      formData.append("file1", filesMap.TemplateUserDetail);
      formData.append("file2", filesMap.TemplateTaskDetails);
      LocalModeApi(formData)
    } else {
      console.log("Both files hould be uploaded for making local mode api call.")
    }
  };

  /**
   * This function takes the payload of uploaded excel files and makes the Local Mode API call
   * @param {*} formData: Payload.
   */
  const LocalModeApi = (formData) => {
    // updating payload for Local Mode API
    formData.append("report_name", "staffing");
    // This times out the loader till charts are generated
    if (formData) {
      setLoaderText(!loaderText);
      setTimeout(() => {
        setLocalLoaderToggle(false);
      }, 3000);
    }
    // call api and get data
    const requestOptions = {
      method: "POST",
      body: formData,
    };
    console.log("REQUEST OPTIONS: ", requestOptions);
    fetch(
      `${process.env.REACT_APP_BASE_URI}/api/local/get_reports/`,
      requestOptions
    )
      // API data recieved
      .then((result) => result.json())
      // Local Mode API data state maintained
      .then((result) => {
        console.log("LOCAL MODE API: ", result)
        if (result.success === true) {
          setLoaderText(!loaderText);
          setApiData(result, true)
          setTimeout(() => {
            setLocalLoaderToggle(false);
          }, 3000);
        } else {
          console.log("FAILED TO LOAD A LOCAL FILE!")
          setLocalLoaderToggle(true);
        }
      }
      ).catch(error => {
        console.error('ERROR IN LOCAL MODE API:', error);
      })
  }

  // process data to get chart data
  let [hrs, recentDte, grid_data] = setPrimaryBarData(reportApiResponse);
  let [cts, brChrtDt] = defaultBarData(reportApiResponse);
  useEffect(() => {
    setHours(hrs);
    setRecentDate(recentDte);
    setRowData(grid_data);
    setCategories(cts);
    setPrimarySeries(brChrtDt);
  }, [hrs, recentDte]);

  // grid export functionality
  const onBtExcelExport = useCallback(() => {
    gridApi.exportDataAsExcel();
  }, []);

  const onBtCSVExport = useCallback(() => {
    gridApi.exportDataAsCsv();
  }, []);

  // loader awaiting api response and page renderx
  const loader =
    primarySeries != [] &&
    hours &&
    recentDate &&
    rowData != [] &&
    categories != [];

  useEffect(() => {
    if (loader) {
      setIsLoading(false);
      setTimeout(() => {
        setLocalLoaderToggle(false);
        setLoaderText(true);
      }, 2000);
    }
  }, [loader]);

  if (isLoading) {
    getStaffingDetails();
    setIsLoading(false)
    return (
      <div>
        <Row className="dashboard-row">
          <div className="spinner">
            <ThreeCircles
              height="100"
              width="100"
              color=""
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
              outerCircleColor="var(--theme1_primary)"
              innerCircleColor="var(--theme1_secondary)"
              middleCircleColor="var(--theme1_tertiary)"
            />
            <h5
              style={{
                position: "relative",
                left: "-5%",
                padding: "10px",
              }}
            >
              Loading your staffing dashboard
            </h5>
          </div>
        </Row>
      </div>
    );
  }

  const MyDocument = (props) => (
    <Document>
      <Page style={styles.page}>
        <View style={styles.layout}>
          <View>
            <img src={chartSvg} />
          </View>
          <View>
            {/* <MainGrid rowData={rowData} onGridReady={onGridReady} /> */}
          </View>
        </View>
      </Page>
    </Document>
  );

  return (
    <>
      <div className="row-wrapper">
        <div className="row-container">
          {localMode ? (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="local-import-row">
                <Col md={2} style={{ paddingLeft: 0, paddingRight: 0 }}>
                  <p style={{ color: "#000", fontWeight: "900", marginBottom: 10, marginRight: 20 }}> Download templates
                    <TemplateDescriptionPopover
                      description={templateDescription}
                    />
                  </p>
                  <Row className="no-gutter">
                    {
                      template_file_list && template_file_list.map((object, index) => (
                        <TemplateDownloadRenderer info={object} key={index} />
                      )
                      )
                    }
                  </Row>
                </Col>
                {
                  template_file_list && template_file_list.map((object, index) => (
                    object.send_back
                      ?
                      <Col md={5} key={index}>
                        <DropFileInput onFileChange={(files) => onFileChange(files, object.name)} message={`Drag and drop ${object.name + "." + object.extension} file here`} />
                      </Col>
                      :
                      <></>
                  )
                  )
                }
              </Row>
            </>
          ) : (
            <>
              <h3 className="intelligence-report-name">{featureName}</h3>
              <Row className="report-card-row">
                <div className="report-card">
                  <div className="chip-header">Hours remaining in busy season</div>
                  <div className="chip-body">{hours}</div>
                </div>
                <div className="report-card">
                  <div className="chip-header">Most recent report date</div>
                  <div className="chip-body">{recentDate}</div>
                </div>
              </Row>
            </>
          )}
        </div>
      </div>
      <div className="row-wrapper">
        <div className="row-container">
          <Tabs
            defaultActiveKey="chart"
            id="uncontrolled-tab-example"
            className="mb-3"
          >
            <Tab eventKey="chart" title="Chart" className="tabs">

              <OffCanvasNavbar
                localtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      {localMode ? (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Go back online
                        </p>
                      ) : (
                        <p style={{ color: "#000", fontWeight: "500" }}>
                          Switch to local mode
                        </p>
                      )}
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={localMode}
                        onClick={() => LocalModeEnabler()}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                secondtoggle={
                  <ButtonGroup>
                    <div className="toggler">
                      <p style={{ color: "#000", fontWeight: "500" }}>{cleanOriginal}</p>
                    </div>
                    <div className="toggler">
                      <Switch
                        isToggled={cleanToggle}
                        onClick={handleClean}
                      ></Switch>
                    </div>
                  </ButtonGroup>
                }
                buttonfirst={
                  <ButtonGroup className="reset-button">
                    <Button
                      onClick={() => setChartModalShow(true)}
                    >
                      Optimize
                    </Button>
                  </ButtonGroup>
                }
                buttonsecond={<></>
                  /* <Button
                    className="reset-button"
                    onClick={() => setPdfModal(true)}
                  >
                    Pdf
                  </Button> */
                }
              />
              <OptimiseChartModal
                show={chartModalShow}
                onHide={() => setChartModalShow(false)}
                fullscreen={true}
              />
              <PdfModal
                show={pdfModal}
                onHide={() => setPdfModal(false)}
              />
              <Row>
                <Col md="12">
                  {localLoaderToggle ? (
                    <div className="chart-container chart-loader">
                      <ThreeCircles
                        height="300"
                        width="300"
                        color=""
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel="--theme1_primary"
                        outerCircleColor="var(--theme1_primary)"
                        innerCircleColor="var(--theme1_tertiary)"
                        middleCircleColor="var(--theme1_quarternary)"
                      />
                      <br />
                      {loaderText ? (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Waiting for you to upload an excel file!
                        </h5>
                      ) : (
                        <h5
                          style={{
                            position: "relative",
                            padding: "10px",
                          }}
                        >
                          Loading your chart!
                        </h5>
                      )}
                    </div>
                  ) : (
                    <MainChart
                      chartref={setChartRef}
                      primarySeries={primarySeries}
                      colors={localChartTheme.colors}
                      categories={categories}
                    />
                  )}
                </Col>
              </Row>
            </Tab>
            <Tab eventKey="grid" title="Grid" className="tabs">
              <DropdownButton
                as={ButtonGroup}
                className="reset-button download-excel"
                title=" Export"
                id="bg-nested-dropdown"
                drop="start"
              >
                <Dropdown.Item onClick={onBtExcelExport}>
                  {" "}
                  <Icon.FileExcel /> Excel Export
                </Dropdown.Item>
                <Dropdown.Item onClick={onBtCSVExport}>
                  {" "}
                  <Icon.FiletypeCsv /> CSV Export
                </Dropdown.Item>
              </DropdownButton>
              <Row>
                <Col md="12" className="grid-row staffing">
                  <MainGrid rowData={rowData} onGridReady={onGridReady} />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </div>
      </div>
    </>
  );
};

export default StaffingReport;
